//预搜索
window.destinationInitVal = $('input[name="regionName"]').val() //为使用预搜索失去焦点时使用
var Config = require('../config/config.js');
var apiPath = Config.env[Config.scheme].apiPath;
var aihuazhuUrl = Config.env[Config.scheme].aihuazhuUrl;
require('./sensorsdata.js')
function preSearch(date,clickDestinationCallback,brandSeries){
  $(document).on('click.closeDest', function(e) {
    var $this = $('.pre-search');
    //有匹配的城市或景点显示匹配的第一个，没有则显示默认的
    var locations = $('.pre-search .locations');
    if(locations.length){
      destinationInitVal = locations.eq(0).data('locations')
      var obj = {
        name: locations.eq(0).data('locations'),
        id: locations.eq(0).data('cityid'),
        type: locations.eq(0).data('type')
      };
      clickDestinationCallback(obj);
    }

    $('input[name="regionName"]').val(destinationInitVal)
    if($this.find($(e.target)).length > 0 || $this[0] === e.target) return;
    setTimeout(function () {
      $('.pre-search')
        .remove();
    }, 30);
  });
  var bind_name = 'input';
  if (navigator.userAgent.indexOf("MSIE") != -1){
    bind_name = 'propertychange';
  }
  $('input[name="regionName"]').bind(bind_name, function(){
    var inputVal = $(this).val()
    if(!inputVal.length){
      $('.hot-city-model').hide()
      $('.pre-search').remove()
      return false;
    }


    var ajaxUrl,data = {
      param: inputVal,
      checkIn: date.checkIn,
      pn: 1,
      checkOut: date.checkOut,
      ps: 50
    }

    if(brandSeries){
      ajaxUrl = apiPath+'/api/hotel/pre_brand_search.json';
      data.brandSeries = brandSeries;
    }else{
      ajaxUrl = apiPath+'/api/hotel/pre_search.json';
    }
    $.ajax({
      //版本号
      headers:{
        ver:206
      },
      url: ajaxUrl,
      type: 'GET',
      cache: false,
      data: data,
      success: function(res) {
        $('.hot-city-model').hide()

        if (res.success) {
          var backHtmlWrap = '<ul class="pre-search" style="top:'+($('.destination').outerHeight()+2)+'px"></ul>';
          var preSearchDiv = $('.pre-search');
          preSearchDiv.length ? preSearchDiv.show() : $('.destination')
            .append(backHtmlWrap);

          var backHtml = '';
          if (res.total == 0) {
            backHtml += '<p>很抱歉没有搜索到匹配结果，换个词试试</p>';
          } else {
            for(var i = 0;i<res.data.locations.length;i++){
              var item = res.data.locations[i];
              if(item.type == 2){//城市
                backHtml += '<li class="locations locationsCity" data-locations="'+item.cityName+'" data-type="'+item.type+'" data-cityid="'+item.city+'"><span>'+item.highlightCityName+','+item.provinceName+'</span><span>城市</span></li>';
              }
              if(item.type == 3){//景点
                backHtml += '<li class="locations locationsSpot" data-locations="'+item.cityName+'" data-type="'+item.type+'" data-landmarkid="'+item.landmarkId+'" data-land="'+item.landmarkName+'"><span>'+item.highlightLandmark+','+item.provinceName+'</span><span>景点</span></li>';
              }
            }
            for(var i = 0;i<res.data.hotels.length;i++){
              var item = res.data.hotels[i];
              backHtml += '<li class="hotels"><a href="javascript:void(0);" data-id="'+item.id+'">'+(item.highlightName||item.name)+'</a><span>酒店</span></li>';
            }
          }
          $('.pre-search').html(backHtml);

          $('.pre-search').find('a')
            .click(function () {
              window.open(aihuazhuUrl+'/detail/'+$(this).data('id'))
            });
          //点击城市
          $('.pre-search').find('.locationsCity')
            .click(function () {
              setTimeout(function () {
                $('.pre-search')
                  .remove();
              }, 0);
              var obj = {
                name: $(this)
                  .data('locations'),
                id: $(this)
                  .data('cityid'),
                type: $(this)
                  .data('type')
              };
              clickDestinationCallback(obj);
            });
          //点击景点
          $('.pre-search').find('.locationsSpot')
            .click(function () {
              setTimeout(function () {
                $('.pre-search')
                  .remove();
              }, 0);
              var obj = {
                name: $(this)
                  .data('land'),
                id: $(this)
                  .data('landmarkid'),
                type: $(this)
                  .data('type')
              };

              clickDestinationCallback(obj);

            });
        } else {

        }
      }
    })
  })
}


exports.preSearch = preSearch;



// WEBPACK FOOTER //
// ./src/js/preSearch.js